/**
 * YACHT® Predictive Search Engine
 * Interacts with Shopify /search/suggest.json API
 */

class YachtPredictiveSearch {
  constructor() {
    this.modal = document.querySelector('[data-search-modal]');
    this.overlay = document.querySelector('[data-drawer-overlay]');
    this.input = document.querySelector('[data-predictive-search-input]');
    this.resultsContainer = document.querySelector('[data-predictive-search-results]');
    this.openTriggers = document.querySelectorAll('[data-open-search-modal]');
    this.closeTriggers = document.querySelectorAll('[data-close-search-modal]');

    this.debounceTimeout = null;
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.openTriggers.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    this.closeTriggers.forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });

    if (this.input) {
      this.input.addEventListener('input', () => {
        clearTimeout(this.debounceTimeout);
        const term = this.input.value.trim();

        if (term.length < 2) {
          if (this.resultsContainer) this.resultsContainer.innerHTML = '';
          return;
        }

        this.debounceTimeout = setTimeout(() => {
          this.fetchResults(term);
        }, 300);
      });
    }
  }

  open() {
    if (this.modal) {
      this.modal.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      setTimeout(() => {
        if (this.input) this.input.focus();
      }, 150);
    }
  }

  close() {
    if (this.modal) {
      this.modal.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
    }
  }

  async fetchResults(term) {
    if (this.resultsContainer) {
      this.resultsContainer.innerHTML = '<div style="padding: 1.5rem 0; color: var(--color-slate);">Searching catalogue...</div>';
    }

    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product,article,page&resources[limit]=6&resources[options][unavailable_products]=last`);
      if (!response.ok) return;

      const data = await response.json();
      this.renderResults(data, term);
    } catch (e) {
      console.error('Error fetching predictive search:', e);
    }
  }

  renderResults(data, term) {
    if (!this.resultsContainer) return;

    const products = data.resources.results.products || [];
    const articles = data.resources.results.articles || [];

    if (products.length === 0 && articles.length === 0) {
      this.resultsContainer.innerHTML = `<div style="padding: 1.5rem 0; color: var(--color-slate);">No results found for "${term}".</div>`;
      return;
    }

    let html = '<div style="display: grid; grid-template-columns: 2fr 1fr; gap: 2rem;">';

    // Products Column
    html += '<div><div class="eyebrow-label">Products</div><div class="product-grid" style="grid-template-columns: repeat(3, 1fr); gap: 1rem;">';
    products.forEach(p => {
      html += `
        <a href="${p.url}" class="product-card" style="text-decoration: none;">
          <div class="product-card__media-wrap">
            <img src="${p.image}" alt="${p.title}" class="product-card__img" />
          </div>
          <div class="product-card__title" style="font-size: 0.8125rem;">${p.title}</div>
          <div class="product-card__price" style="font-size: 0.8125rem;">${p.price}</div>
        </a>
      `;
    });
    html += '</div></div>';

    // Articles Column (Journal)
    html += '<div><div class="eyebrow-label">Journal Stories</div><div style="display: flex; flex-direction: column; gap: 0.75rem;">';
    if (articles.length > 0) {
      articles.forEach(a => {
        html += `
          <a href="${a.url}" style="font-family: var(--font-heading); font-size: 0.875rem; font-weight: 600; color: var(--color-navy); display: block;">
            ${a.title}
          </a>
        `;
      });
    } else {
      html += '<p style="font-size: 0.8125rem; color: var(--color-slate-light);">No matching stories.</p>';
    }
    html += '</div></div>';

    html += '</div>';
    html += `<div style="margin-top: 1.5rem; text-align: center;"><a href="/search?q=${encodeURIComponent(term)}" class="link-arrow">View all results for "${term}" →</a></div>`;

    this.resultsContainer.innerHTML = html;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.yachtSearch = new YachtPredictiveSearch();
});
